import axios from 'axios'

export default ({ app }, inject) => {
  // Crear una instancia de axios con la baseURL configurada
  const api = axios.create({
    baseURL: ''
  })

  // Injectar la instancia axios como $api en toda la aplicación
  inject('axios', api)
}